import type { FaireProductEntity } from "../../entity_types/product";

export const p_svkmpmfnuy: FaireProductEntity = {
  token: "p_svkmpmfnuy",
  type: "product",
  name: "Butter Sticker",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/a757c0d7ba2aad850412794087325084c691487a7249d46adb394c5112a2c5d9.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/130c49f23563b471e6a0838941775a448ed7d72384345f3cc6b05b7d9a3ea780.jpeg",
    "https://cdn.faire.com/fastly/5ec0d5d1c2008c92a4cbf5c0b86d404b6ecd4a1a09078d4336fffae4aed8ca40.png",
  ],
  priceDollars: 2.5,
  description:
    "Water-resistant, Die-cut Stickers with crack and peel backing. Have fun decorating those laptops and water bottles!",
  tags: [],
  msrpDollars: 5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:51.241Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
